const facility = {
  state: {
    facility: null, // main company logged in
    facilityDID: null,
    facilityAccess: null,
    facilityRegister: null,
    facilityRegisterCounter: null,
    facilityList: null,
    facilityListCounter: 0
  },
  mutations: {
    changeFacility(state, payload) {
      state.facility = payload;
    },
    changeFacilityDID(state, payload) {
      state.facilityDID = payload;
    },
    changeFacilityAccess(state, payload) {
      state.facilityAccess = payload;
    },
    changeFacilityRegister(state, payload) {
      state.facilityRegister = payload;
    },
    changeFacilityRegisterCounter(state, payload) {
      state.facilityRegisterCounter = payload;
    },
    changeFacilityList(state, payload) {
      state.facilityList = payload;
    },
    changeFacilityListCounter(state, payload) {
      state.facilityListCounter = payload;
    }
  },
  actions: {
    changeFacility({ commit }, payload) {
      commit("changeFacility", payload);
    },
    changeFacilityDID({ commit }, payload) {
      commit("changeFacilityDID", payload);
    },
    changeFacilityAccess({ commit }, payload) {
      commit("changeFacilityAccess", payload);
    },
    changeFacilityRegister({ commit }, payload) {
      commit("changeFacilityRegister", payload);
    },
    changeFacilityRegisterCounter({ commit }, payload) {
      commit("changeFacilityRegisterCounter", payload);
    },
    changeFacilityList({ commit }, payload) {
      commit("changeFacilityList", payload);
    },
    changeFacilityListCounter({ commit }, payload) {
      commit("changeFacilityListCounter", payload);
    }
  },
  getters: {
    getFacility: state => {
      return state.facility;
    },
    getFacilityDID: state => {
      return state.facilityDID;
    },
    getFacilityAccess: state => {
      return state.facilityAccess;
    },
    getFacilityRegister: state => {
      return state.facilityRegister;
    },
    getFacilityRegisterCounter: state => {
      return state.facilityRegisterCounter;
    },
    getFacilityList: state => {
      return state.facilityList;
    },
    getFacilityListCounter: state => {
      return state.facilityListCounter;
    }
  }
};
export default facility;
